// plugin.js
module.exports = {
  install: function (less, pluginManager, functions) {
    functions.add('px', function (param) {
      if (param.value) {
        return Number(param.value) + 'PX'
      } else {
        return Number(eval(`${param.operands[0].value}${param.op}${param.operands[1].value}`)) * 8 + 'px'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/plugin.js